<template>
  <v-dialog
    :value="show"
    fullscreen
    persistent
    class="toolbar"
    transition="dialog-bottom-transition"
  >
    <v-toolbar absolute>
      <v-toolbar-title>{{ $t('title.ticket') }}</v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          class="btn"
          icon
          @click="close"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card>
      <v-container
        fluid
        style="padding-top: 60px"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
            offset-md="3"
            lg="4"
            offset-lg="4"
          >
            <ticket
              v-if="show"
              :use-listener="useListener"
              :tickets="tickets"
              :start-print="startPrint"
              :solde="solde"
              :message="message"
              :carrier="carrier"
              :send="send"
              is-modal
              @hide="close"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Ticket from '../Ticket'

export default {
  name: 'TicketDialog',

  components: {
    Ticket
  },

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: false },
    useListener: { type: Boolean, default: true },
    //
    tickets: { type: Array, default: null },
    startPrint: { type: Boolean, default: false },
    solde: { type: String, default: '' },
    message: { type: String, default: '' },
    carrier: { type: Object, default: null },
    send: { type: String, default: null }
  },

  methods: {
    close () {
      this.$emit('change', false)
      this.$emit('close')
    }
  }
}
</script>
